import AdminLayout from '../../components/admin-layout';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import EventCalendar from '../../components/Calendar/EventCalendar';
import CMHeader from '../../PageComponentData/Common/Pageheader';
import { useEffect } from 'react';
function CalendarIndex() {
  useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
  return (
    <AdminLayout headerTxt={'Calendar'}>
       <CMHeader headertxt='Calendar' />
      <div className="p-4">
          <EventCalendar />
      </div>
    </AdminLayout>
  );
}

export default CalendarIndex;
